<template>
  <div class="tab">
    <el-footer v-if="$can('create', 'cameras_recipients')" class="tab__footer page__active_bar">
      <el-button class="page__active_button" type="primary" @click="addDialog = true" icon="el-icon-share">
        Предоставить доступ
      </el-button>
    </el-footer>
    <main class="page_container">
      <el-table :data="recipients">
        <el-table-column prop="client_name" label="Полное имя" />
        <el-table-column prop="login" label="Логин" />
        <el-table-column prop="is_access_archive" label="Доступ к архиву" align="center">
          <template slot-scope="scope">
            <el-switch
              :value="!!scope.row.is_access_archive"
              @change="onSwitchArchiveAccess(scope.row)" :disabled="!$can('update', 'cameras_recipients')"
            />
          </template>
        </el-table-column>
        <el-table-column prop="is_access_sound" label="Звук" align="center">
          <template slot-scope="scope">
            <el-switch
              :value="!!scope.row.is_access_sound"
              @change="onSwitchSoundAccess(scope.row)" :disabled="!$can('update', 'cameras_recipients')"
            />
          </template>
        </el-table-column>
        <el-table-column prop="is_notify_by_push" label="Push" align="center">
          <template slot-scope="scope">
            <el-switch
              :value="!!scope.row.is_notify_by_push"
              @change="onSwitchPushNotify(scope.row)" :disabled="!$can('update', 'cameras_recipients')"
            />
          </template>
        </el-table-column>
        <el-table-column prop="is_notify_by_telegram" label="Telegram" align="center">
          <template slot-scope="scope">
            <el-switch
              :value="!!scope.row.is_notify_by_telegram"
              @change="onSwitchTelegramNotify(scope.row)" :disabled="!$can('update', 'cameras_recipients')"
            />
          </template>
        </el-table-column>
        <el-table-column v-if="$can('delete', 'cameras_recipients')" label="Действия" align="right">
          <template slot-scope="scope">
            <el-button type="danger" size="small" @click="onDelete(scope.row)">Удалить</el-button>
          </template>
        </el-table-column>
      </el-table>
    </main>
    <camera-recipient-create-modal :camera-id="cameraId" :visible.sync="addDialog" @closed="addDialog = false" />
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import CameraRecipientCreateModal from "@/components/Cameras/components/Camera/features/CameraRecipientCreateModal";

export default {
  name: "CameraAccessSettings",
  components: { CameraRecipientCreateModal },
  props: {
    cameraId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      addDialog: false,
    };
  },
  computed: {
    ...mapState("cameras", ["recipients", "camera"]),
  },
  created() {
    this.getRecipients(this.cameraId);
  },
  methods: {
    ...mapActions("cameras", {
      getRecipients: "GET_CAMERA_RECIPIENTS",
      updateRecipient: "UPDATE_CAMERA_RECIPIENT",
      deleteRecipient: "REMOVE_CAMERA_RECIPIENT",
    }),
    onSwitchArchiveAccess(recipient) {
      this.$confirm(
        `${recipient.is_access_archive ? "Удалить у пользователя" : "Предоставить пользователю"} <b>${
          recipient.client_name
        }</b> доступ к архиву камеры <b>${this.camera.short_name}</b>`,
        "Редактирование доступа к архиву",
        {
          confirmButtonText: recipient.is_access_archive ? "Удалить доступ" : "Предоставить доступ",
          cancelButtonText: "Отменить",
          confirmButtonClass: recipient.is_access_archive ? "el-button--danger" : "",
          dangerouslyUseHTMLString: true,
          type: "warning",
        }
      )
        .then(() =>
          this.updateRecipient({
            id_camera: this.cameraId,
            id_camera_share: recipient.id_camera_share,
            is_access_archive: !recipient.is_access_archive,
            is_access_sound: recipient.is_access_sound,
            is_notify_by_push: recipient.is_notify_by_push,
            is_notify_by_telegram: recipient.is_notify_by_telegram,
          })
        )
        .then(() => {
          this.$message.success(`Доступ к архиву камеры для пользователя ${recipient.client_name} изменен`);
          this.$root.$emit("camera-sharing-history-refresh");
        });
    },
    onSwitchSoundAccess(recipient) {
      this.$confirm(
        `${recipient.is_access_sound ? "Удалить у пользователя" : "Предоставить пользователю"} <b>${
          recipient.client_name
        }</b> доступ к звуку камеры <b>${this.camera.short_name}</b>`,
        "Редактирование доступа к звуку",
        {
          confirmButtonText: recipient.is_access_sound ? "Удалить доступ" : "Предоставить доступ",
          cancelButtonText: "Отменить",
          confirmButtonClass: recipient.is_access_sound ? "el-button--danger" : "",
          dangerouslyUseHTMLString: true,
          type: "warning",
        }
      )
        .then(() =>
          this.updateRecipient({
            id_camera: this.cameraId,
            id_camera_share: recipient.id_camera_share,
            is_access_archive: recipient.is_access_archive,
            is_access_sound: !recipient.is_access_sound,
            is_notify_by_push: recipient.is_notify_by_push,
            is_notify_by_telegram: recipient.is_notify_by_telegram,
          })
        )
        .then(() => {
          this.$message.success(`Доступ к звуку камеры для пользователя ${recipient.client_name} изменен`);
          this.$root.$emit("camera-sharing-history-refresh");
        });
    },
    onSwitchPushNotify(recipient) {
      this.$confirm(
        `${recipient.is_notify_by_push ? "Удалить у пользователя" : "Предоставить пользователю"} <b>${
          recipient.client_name
        }</b> доступ к push уведолмениям для камеры <b>${this.camera.short_name}</b>`,
        "Редактирование доступа к push уведомлениям",
        {
          confirmButtonText: recipient.is_notify_by_push ? "Удалить доступ" : "Предоставить доступ",
          cancelButtonText: "Отменить",
          confirmButtonClass: recipient.is_notify_by_push ? "el-button--danger" : "",
          dangerouslyUseHTMLString: true,
          type: "warning",
        }
      )
        .then(() =>
          this.updateRecipient({
            id_camera: this.cameraId,
            id_camera_share: recipient.id_camera_share,
            is_access_archive: recipient.is_access_archive,
            is_access_sound: recipient.is_access_sound,
            is_notify_by_push: !recipient.is_notify_by_push,
            is_notify_by_telegram: recipient.is_notify_by_telegram,
          })
        )
        .then(() => {
          this.$message.success(`Доступ к push уведомлениям камеры для пользователя ${recipient.client_name} изменен`);
          this.$root.$emit("camera-sharing-history-refresh");
        });
    },
    onSwitchTelegramNotify(recipient) {
      this.$confirm(
        `${recipient.is_notify_by_telegram ? "Удалить у пользователя" : "Предоставить пользователю"} <b>${
          recipient.client_name
        }</b> доступ к Telegram уведолмениям для камеры <b>${this.camera.short_name}</b>`,
        "Редактирование доступа к Telegram уведомлениям",
        {
          confirmButtonText: recipient.is_notify_by_telegram ? "Удалить доступ" : "Предоставить доступ",
          cancelButtonText: "Отменить",
          confirmButtonClass: recipient.is_notify_by_telegram ? "el-button--danger" : "",
          dangerouslyUseHTMLString: true,
          type: "warning",
        }
      )
        .then(() =>
          this.updateRecipient({
            id_camera: this.cameraId,
            id_camera_share: recipient.id_camera_share,
            is_access_archive: recipient.is_access_archive,
            is_access_sound: recipient.is_access_sound,
            is_notify_by_push: recipient.is_notify_by_push,
            is_notify_by_telegram: !recipient.is_notify_by_telegram,
          })
        )
        .then(() => {
          this.$message.success(`Доступ к Telegram уведомлениям для пользователя ${recipient.client_name} изменен`);
          this.$root.$emit("camera-sharing-history-refresh");
        });
    },
    onDelete(recipient) {
      this.$confirm(
        `Удалить доступ пользователю <b>${recipient.client_name}</b> к камере <b>${this.camera.short_name}</b>`,
        "Удаление доступа к камере",
        {
          confirmButtonText: "Удалить",
          cancelButtonText: "Отменить",
          confirmButtonClass: "el-button--danger",
          dangerouslyUseHTMLString: true,
          type: "warning",
        }
      )
        .then(() => this.deleteRecipient({ id_camera: this.cameraId, id_camera_share: recipient.id_camera_share }))
        .then(() => {
          this.$message.success(`Доступ к камере для пользователя ${recipient.client_name} удален`);
          this.$root.$emit("camera-sharing-history-refresh");
        });
    },
  },
};
</script>
